import React, { useState, useEffect } from 'react'
import { T, GameLogos } from './ui'
import { getNFLSlate } from './api'

// Top game ticker — a horizontal, scrollable strip of every game this week that acts as a GLOBAL
// QUICK FILTER (the quick-access bar every sportsbook app has). Tap a game and the whole app — the
// board, Fades, Locks — scopes to just that matchup's two teams, so you can look at "just tonight"
// or "just Jacksonville" without the rest of the weekend's clutter. Tap "All", or the active chip
// again, to clear. The selected chip stays highlighted across tabs so the active scope is always clear.
export default function GameTicker({ season, week, filter, onFilter }) {
  const [games, setGames] = useState(null)
  useEffect(() => {
    let a = true
    getNFLSlate(season, week).then(r => { if (a) setGames(r.games || []) })
    return () => { a = false }
  }, [season, week])

  if (!games || !games.length) return null
  const kc = (a, b) => {
    const ka = a.kickoff || a.gameday || '', kb = b.kickoff || b.gameday || ''
    return ka === kb ? 0 : !ka ? 1 : !kb ? -1 : (ka < kb ? -1 : 1)
  }
  const list = games.slice().sort((a, b) => ((a.state === 'final') - (b.state === 'final')) || kc(a, b))
  const activeId = filter && filter.game_id

  const chipStyle = (on, live) => ({
    flexShrink: 0, cursor: 'pointer', minWidth: 90, textAlign: 'left',
    color: on ? '#04140D' : T.text,
    background: on ? T.green : T.card,
    border: `1px solid ${on ? T.green : live ? T.blue : T.border}`,
    borderRadius: 10, padding: '6px 10px',
  })

  return (
    <div style={{ display: 'flex', gap: 7, overflowX: 'auto', padding: '8px 16px', background: '#0B1018',
      borderBottom: `1px solid ${T.border}`, WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none' }}>
      {/* All — clears the filter */}
      <button onClick={() => onFilter(null)} style={chipStyle(!filter, false)} aria-pressed={!filter}>
        <div style={{ fontSize: 12.5, fontWeight: 800, whiteSpace: 'nowrap' }}>All games</div>
        <div style={{ fontSize: 10, color: !filter ? '#04140D' : T.muted, fontWeight: 700, marginTop: 2 }}>{list.length} this week</div>
      </button>
      {list.map(g => {
        const on = activeId === g.game_id
        const live = g.state === 'live', final = g.state === 'final'
        const hasScore = g.away_score != null && g.home_score != null
        const sub = final ? (hasScore ? `${g.away_score}-${g.home_score} F` : 'Final')
          : live ? (hasScore ? `${g.away_score}-${g.home_score}` : 'LIVE')
          : (g.time || g.day || '—')
        const a = g.away?.abbr || '—', h = g.home?.abbr || '—'
        return (
          <button key={g.game_id} aria-pressed={on} aria-label={`Filter to ${a} at ${h}`}
            onClick={() => onFilter(on ? null : { game_id: g.game_id, teams: [a, h], label: `${a} @ ${h}` })}
            style={chipStyle(on, live)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              {!on && <span style={{ width: 5, height: 5, borderRadius: 999, flexShrink: 0,
                background: live ? T.blue : final ? T.faint : T.green }} />}
              <GameLogos away={a} home={h} size={20} names color={on ? '#04140D' : undefined} />
            </div>
            <div style={{ fontSize: 10, fontWeight: 700, marginTop: 2, whiteSpace: 'nowrap',
              color: on ? '#04140D' : live ? T.blue : T.muted }}>{sub}</div>
          </button>
        )
      })}
    </div>
  )
}
